"use client";

import { useSessionWorkspace } from "@/components/providers/org_provider";
import Link from "next/link";

// Centred, as the study surfaces' crumbs are. The root names the org,
// so a multi-org reader can tell which one they are in; a page that is not
// the org's, such as the account, leaves it off.
export const PageBreadcrumb = ({
  current,
  isOrgScoped = true,
}: {
  current: string;
  isOrgScoped?: boolean;
}) => {
  const { org: workspace } = useSessionWorkspace();
  return (
    <div className="flex h-full min-w-0 flex-1 items-center justify-center px-12 md:px-2">
      {/* A phone's bar is the mark and the sheet's trigger alone. */}
      <nav
        aria-label="Breadcrumb"
        className="flex min-w-0 items-center text-sm max-md:hidden"
      >
        {isOrgScoped && workspace ? (
          <>
            <Link
              href="/dashboard"
              className="max-w-[200px] truncate whitespace-nowrap text-content-tertiary hover:text-content-primary"
            >
              {workspace.name}
            </Link>
            <span className="mx-1.5 text-content-tertiary">/</span>
          </>
        ) : null}
        <span className="whitespace-nowrap text-content-primary">
          {current}
        </span>
      </nav>
    </div>
  );
};
PageBreadcrumb.displayName = "Page.Breadcrumb";
